import { NgModule } from '@angular/core';

import { TranslocoDatePipe } from './dateTransloco.pipe';
import { DidDatePassPipe } from './didDatePass.pipe';
import { FilterCallbackPipe } from './filterCallbackPure.pipe';
import { FirstLetterLowercasePipe } from './firstLetterLowercase.pipe';
import { FormArrayPipe } from './formArray.pipe';
import { FormControlPipe } from './formControl.pipe';
import { FormGroupPipe } from './formGroup.pipe';
import { GetTranslationPipe } from './getTranslation.pipe';
import { PhonePipe } from './phone.pipe';
import { TitlecaseFirstLetterPipe } from './titlecaseFirstLetter.pipe';

const PIPES = [
  FormControlPipe,
  FormGroupPipe,
  FilterCallbackPipe,
  GetTranslationPipe,
  DidDatePassPipe,
  FirstLetterLowercasePipe,
  TranslocoDatePipe,
  FormArrayPipe,
  TitlecaseFirstLetterPipe,
  PhonePipe,
];

@NgModule({
  imports: [],
  declarations: [PIPES],
  exports: [PIPES],
})
export class SharedUtilsPipesModule {}
